import {createContext} from "react";

const ListHasChangedContext = createContext([]);

export {
  ListHasChangedContext
}